module.exports = __webpack_public_path__ + "img/bb_g3_t_antenna-01.1733538d.svg";